import React from 'react';
import { 
  Box, 
  Typography, 
  FormControl, 
  FormControlLabel, 
  RadioGroup, 
  Radio,
  Paper,
  Divider
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const DataConfig = ({ config, onChange }) => {
  const handleFormatoChange = (event) => {
    onChange({
      ...config,
      formato: event.target.value
    });
  };

  // Exemplo de data para visualização
  const getExemploData = () => {
    const hoje = new Date();
    
    switch (config.formato) {
      case 'DD/MM/AA':
        return format(hoje, 'dd/MM/yy');
      case 'DD/MM/AAAA':
        return format(hoje, 'dd/MM/yyyy');
      case 'MM/DD/AA':
        return format(hoje, 'MM/dd/yy');
      case 'MM/DD/AAAA':
        return format(hoje, 'MM/dd/yyyy');
      case 'DD de MMMM de AAAA':
        return format(hoje, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
      default:
        return format(hoje, 'dd/MM/yyyy');
    }
  };

  return (
    <Paper sx={{ p: 2, borderRadius: 2, flex: 1, minWidth: 250 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CalendarTodayIcon sx={{ mr: 1, color: 'primary.main' }} />
        <Typography variant="h6">
          Formato da Data
        </Typography>
      </Box>
      
      <Divider sx={{ mb: 2 }} />
      
      <FormControl component="fieldset">
        <Typography variant="subtitle2" gutterBottom sx={{ mb: 1 }}>
          Formato da data:
        </Typography>
        <RadioGroup
          value={config.formato}
          onChange={handleFormatoChange}
        >
          <FormControlLabel value="DD/MM/AA" control={<Radio />} label="DD/MM/AA" />
          <FormControlLabel value="DD/MM/AAAA" control={<Radio />} label="DD/MM/AAAA" />
          <FormControlLabel value="MM/DD/AA" control={<Radio />} label="MM/DD/AA" />
          <FormControlLabel value="MM/DD/AAAA" control={<Radio />} label="MM/DD/AAAA" />
          <FormControlLabel 
            value="DD de MMMM de AAAA" 
            control={<Radio />} 
            label="DD de Mês por extenso de AAAA" 
          />
        </RadioGroup>
      </FormControl>

      <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
        <Typography variant="caption" display="block" gutterBottom>
          VISUALIZAÇÃO:
        </Typography>
        <Typography variant="h5" sx={{ fontFamily: 'monospace', fontWeight: 'medium' }}>
          {getExemploData()}
        </Typography>
      </Box>
    </Paper>
  );
};

export default DataConfig; 